import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * Rehydrates the serialized image from a proxy toast
 * @param htmlString
 * @constructor
 */
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const RehydratedImage = _ref => {
  let {
    htmlString
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [parse(DOMPurify.sanitize(htmlString)), " "]
  });
};